import DeleteShopSupplierByIdRequestModelBase from '../_generated/modelBases/delete-shop-supplier-by-id-request-model-base';

export default class DeleteShopSupplierByIdRequestModel extends DeleteShopSupplierByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
